import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { formatWebinarTime } from "@/lib/format";
import { Clock, Video, Calendar, User, ArrowRight } from "lucide-react";

const IND_LABEL = { ai: "AI", "real-estate": "Real Estate", insurance: "Insurance", loans: "Loans" };

export default function WebinarCard({ webinar, ctaTo }) {
  const { timezone } = useApp();
  const { dayLabel, time, tzShort } = formatWebinarTime(webinar.start_utc, timezone);
  const to = ctaTo || `/webinar/${webinar.instance_id}/register`;
  return (
    <div data-testid="webinar-card" className="relative rounded-3xl p-[1px] bg-gradient-to-br from-asf-orange/60 via-white/10 to-transparent">
      <div className="rounded-3xl bg-slate-100 p-6 sm:p-8">
        <div className="flex flex-col md:flex-row md:items-center gap-6">
          <div className="flex-1">
            <div className="asf-overline mb-2">Your Next {IND_LABEL[webinar.topic]} Webinar</div>
            <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{webinar.title}</h3>
            <p className="text-slate-500 mt-2 max-w-md">{webinar.tagline}</p>
            <div className="flex flex-wrap gap-x-6 gap-y-2 mt-5 text-sm">
              <span className="flex items-center gap-2 text-slate-600"><Calendar className="h-4 w-4 text-asf-orange" /> {dayLabel}</span>
              <span className="flex items-center gap-2 text-slate-600"><Clock className="h-4 w-4 text-asf-orange" /> {webinar.duration_min} min</span>
              <span className="flex items-center gap-2 text-slate-600"><Video className="h-4 w-4 text-asf-orange" /> {webinar.location}</span>
              <span className="flex items-center gap-2 text-slate-600"><User className="h-4 w-4 text-asf-orange" /> {webinar.host}</span>
            </div>
          </div>
          <div className="md:w-56 shrink-0 text-center md:text-right">
            <div className="rounded-2xl bg-asf-app/60 border border-slate-200 p-4 mb-4">
              <div className="font-display text-4xl font-extrabold text-slate-900 leading-none">{time}</div>
              <div className="text-xs text-slate-500 mt-1">{tzShort} · your local time</div>
            </div>
            <Link to={to} data-testid="reserve-seat-btn" className="btn-primary w-full inline-flex items-center justify-center gap-2 px-6 py-3.5">
              Reserve My Seat <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
